module.exports = __webpack_public_path__ + "static/media/puresore_mobile.c7ff6f56.png";